export {default as Delaunay} from "./delaunay.js";
export {default as Voronoi} from "./voronoi.js";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-delaunay/src/index.js
// module id = 984
// module chunks = 0